import React from 'react';
import { Input } from '../UI';
import SearchLoader from './SearchLoader';

const SearchInput = ({
  value,
  onChange,
  onKeyDown,
  placeholder,
  isLoading = false,
  className = '',
  showClearButton = true,
  onClear,
  ...props
}) => {
  const handleClear = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className={`relative ${className}`}>
      <Input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        className={`w-full pl-10 ${showClearButton && value ? 'pr-20' : 'pr-10'} transition-all duration-200 ${
          isLoading ? 'border-primary-300 bg-primary-50/50' : ''
        }`}
        {...props}
      />
      
      {/* Search Icon / Loading Indicator */}
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        {isLoading ? (
          <SearchLoader size="sm" className="text-primary-500" />
        ) : (
          <svg className="h-5 w-5 text-gray-400 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        )}
      </div>

      {/* Loading Indicator on Right */}
      {isLoading && (
        <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-primary-500 rounded-full animate-ping"></div>
            <span className="text-xs text-primary-600 font-medium">Searching...</span>
          </div>
        </div>
      )}

      {/* Clear Button */}
      {showClearButton && value && !isLoading && (
        <button
          onClick={handleClear}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200 group"
        >
          <div className="relative">
            <svg className="h-5 w-5 group-hover:scale-110 transition-transform duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
            <div className="absolute inset-0 rounded-full bg-gray-100 opacity-0 group-hover:opacity-20 transition-opacity duration-200"></div>
          </div>
        </button>
      )}
    </div>
  );
};

export default SearchInput;